let oscar = "https://publimed.net/iconos/testimonios/TestimonioOscar.mp4";
let simulador = "https://publimed.net/iconos/testimonios/simulador.mp4";

let im1 = "https://publimed.net/iconos/testimonios/im1.png";
let im2 = "https://publimed.net/iconos/testimonios/im2.png";
let im3 = "https://publimed.net/iconos/testimonios/im3.jpeg";
let im4 = "https://publimed.net/iconos/testimonios/im4.jpeg";
let im5 = "https://publimed.net/iconos/testimonios/im5.jpeg";
let im6 = "https://publimed.net/iconos/testimonios/im6.jpeg";
let im7 = "https://publimed.net/iconos/testimonios/im7.jpeg";
let im8 = "https://publimed.net/iconos/testimonios/im8.jpeg";
let im9 = "https://publimed.net/iconos/testimonios/im9.jpeg";

export const testimoniosV = [oscar, simulador];

export const testimoniosC = [im1, im2, im3, im4, im5, im6, im7, im8, im9];
